import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ElementViewDigest } from '../model/element-columns-digest';
import { ServiceService } from '../service/service.service';
import { IMenu } from './model';

@Component({
	selector: 'common-view-selector',
	templateUrl: './view-selector.component.html',
	styleUrls: ['./view-selector.component.scss']
})
export class ViewSelectorComponent implements OnInit {
	@Output() managerClick = new EventEmitter();
	@Input() selectedValue: string;
	@Input() menuItems: IMenu[];
	constructor(public svr: ServiceService) {}

	ngOnInit() {}
	menuClick(val: ElementViewDigest) {
		this.svr.data.selectedView = val;
		this.svr.refreshData().subscribe();
	}
}
